/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Picker_Placeholder_BadgeInputs */

const en_map_picker_placeholder_badge = /** @type {(inputs: Map_Picker_Placeholder_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coming soon`)
};

const fr_map_picker_placeholder_badge = /** @type {(inputs: Map_Picker_Placeholder_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`à venir`)
};

const ms_sg2_map_picker_placeholder_badge = /** @type {(inputs: Map_Picker_Placeholder_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`akan datang`)
};

/**
* | output |
* | --- |
* | "coming soon" |
*
* @param {Map_Picker_Placeholder_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_picker_placeholder_badge = /** @type {((inputs?: Map_Picker_Placeholder_BadgeInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Picker_Placeholder_BadgeInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_picker_placeholder_badge(inputs)
	if (locale === "fr") return fr_map_picker_placeholder_badge(inputs)
	return ms_sg2_map_picker_placeholder_badge(inputs)
});